import $ from 'jquery'
import 'bootstrap'

function openImageModal(src, alt = '') {
  const $img = $('#imageModalImg')
  $img.attr('src', src)
  $img.attr('alt', alt)
  const $modal = $('#imageModal')
  $modal.modal('show')
}

// Delegate click on any element with data-image-modal attribute
$(document).on('click', '[data-image-modal]', function (e) {
  e.preventDefault()
  const $el = $(this)
  const src = $el.data('image-src') || $el.attr('href') || $el.find('img').attr('src')
  const alt = $el.data('image-alt') || $el.find('img').attr('alt') || ''
  if (src) openImageModal(src, alt)
})

export { openImageModal }
